import React from 'react';

var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.293 18.293a1 1 0 0 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414l-7-7a1 1 0 0 0-1.414 1.414L14.586 12l-6.293 6.293z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowRight.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ArrowRight as icon };
export default iconHandler(ArrowRight);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ArrowRight.js
// module id = 581
// module chunks = 0